import { createContext, useEffect, useState } from "react";
import { useRouter } from "next/compat/router";
import { getRelativePathFromLink } from "./url";
import { Post } from "@/wp/types/client";

/**
 * Language Context For Global State
 * @returns context of the provider in the whole application
 */
export const LanguageContext = createContext({
  toggle: "de",
  setToggle: (_toggleVal: string) => {
    // TODO fill with content
  },
});

/**
 * Language Provider Wrapped Around Application
 */
export const LanguageProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const { toggle, setToggle } = useToggle();

  return (
    <LanguageContext.Provider value={{ toggle, setToggle }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useToggle = () => {
  const router = useRouter();
  const [lang, setLang] = useState<string>(router?.locale ?? "de");

  useEffect(() => {
    if (router?.locale) {
      setLang(router.locale);
    }
  }, [router?.locale]);

  const setToggle = (lang: string) => {
    if (typeof window !== "undefined") {
      document.documentElement.lang = lang;
      if (router?.locale) {
        setLang(router.locale);
      }
    }
  };

  return { toggle: lang, setToggle };
};

/**
 * **Path Translator**
 * @returns *available translations for the current page*
 */
export const pathTranslator = (post: Post) => {
  const availableTranslations: { lang: string; path: string }[] = [];

  if (!post) return availableTranslations;

  if (post.wpml_translations) {
    post.wpml_translations.map((info) => {
      if (
        (process.env.NEXT_PUBLIC_LOCALES?.split(",") ?? ["de"]).some(
          (l) => l === info.locale.split("_")[0],
        )
      ) {
        availableTranslations.push({
          lang: info.locale.split("_")[0],
          path: getRelativePathFromLink(info.href),
        });
      }
    });
  }

  return availableTranslations;
};

export const dynamicPath = (href: string) => {
  const url = href.split("/");
  if (url[url.length - 1] !== "") {
    // Url has no / at the end
    return url[url.length - 1];
  } else {
    // Url has / at the end
    return url[url.length - 2];
  }
};
